import { useCallback, useContext, useMemo, useState, useEffect } from 'react';
import { QuizContext } from '../context/QuizContext';

export const useQuizStep = (id: string) => {
  const {
    back,
    trackAnalyticForStep,
    next,
    getStepData,
    updateUserPreferences,
    updateUserInteraction,
    userPreferences,
    navigateToInitialStep,
    signInUser,
    signUpUser,
    signUpWithGoogle,
    signUpWithFacebook,
    updateUserSettings,
    baseUrl,
    totalSteps,
    flowName,
  } = useContext(QuizContext);

  const initialStep = getStepData(id)?.index as number;

  const [stepOrder, setStepOrder] = useState(initialStep);

  const stepData = useMemo(
    () => getStepData(id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id],
  );

  const backStep = useCallback(() => {
    setStepOrder((prev) => prev - 1);
    back(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const nextStep = useCallback(
    (text?: string, key?: string) => {
      setStepOrder((prev) => prev + 1);
      next({ id, text, key });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id],
  );

  useEffect(() => {
    trackAnalyticForStep(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return {
    back: backStep,
    next: nextStep,
    stepData,
    updateUserPreferences,
    updateUserInteraction,
    updateUserSettings,
    navigateToInitialStep,
    userPreferences,
    signInUser,
    signUpUser,
    signUpWithGoogle,
    signUpWithFacebook,
    baseUrl,
    totalSteps,
    stepOrder,
    flowName,
  };
};
